angular.module('eCareVault.customAttributeTemplate', []);
